import { createRouter, createWebHistory } from 'vue-router';

import index from '@/components/index';
import about from '@/components/about';
import contact from '@/components/contact';
import NetworkProtection from '@/components/NetworkProtection';
import ManagedIT from '@/components/ManagedIT';
import OilfieldIT from '@/components/OilfieldIT';
import CameraNVR from '@/components/CameraNVR';
import ServiceArea from '@/components/ServiceArea';

const routes = [
    { path: '/', name: 'index', component: index },
    { path: '/about', name: 'about', component: about },
    { path: '/contact', name: 'contact', component: contact },
    { path: '/network-protection', name: 'network-protection', component: NetworkProtection },
    { path: '/managed-it-services', name: 'managed-it-services', component: ManagedIT },
    { path: '/oilfield-remote-it', name: 'oilfield-remote-it', component: OilfieldIT },
    { path: '/camera-nvr-networks', name: 'camera-nvr-networks', component: CameraNVR },
    { path: '/service-area', name: 'service-area', component: ServiceArea },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
